import React from 'react';
import { Router, Route, browserHistory } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import AboutPage from '../components/AboutPage';

function RouterConfig(props) {
  return (
    <LocaleProvider locale={ja_JP}>
      <Router history={props.history}>
        {/*         <Route path="/" component={AboutPage} /> */}
        <Route path="/" render={() => <AboutPage appKey={props.app.appkey} />} />
      </Router>
    </LocaleProvider>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/about/config/router.js